import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { isExpired } from 'react-jwt';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ROLE } from '../../../enums';
import { UserService } from '../../../services';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { login, selectIsAuthenticated } from '../../../store/reducers';
import style from './Login.module.scss';

export function Login(): React.JSX.Element {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    const tokenString = sessionStorage.getItem('token');
    const token = tokenString !== null ? atob(tokenString) : undefined;
    const userString = sessionStorage.getItem('user');
    const user = userString !== null ? JSON.parse(atob(userString)) : undefined;
    const departmentString = sessionStorage.getItem('department');
    const department = departmentString !== null ? JSON.parse(atob(departmentString)) : undefined;

    if (token && user) {
      if (isExpired(token)) {
        sessionStorage.clear();
      }
      if (!isExpired(token)) {
        dispatch(
          login({
            user,
            token,
            department,
            isAuthenticated: true,
            isAdmin: user.role === ROLE.FD_ADMIN,
            isSuperAdmin: user.role === ROLE.ADMIN,
          })
        );
      }
    }

    if (isAuthenticated || (token && user)) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, []);

  const handleLogin = async (): Promise<void> => {
    const loginResponse = await UserService.login({ email, password });
    if (loginResponse.error) {
      toast.error('Fehler beim Einloggen!');

      return;
    }

    const responseData = loginResponse.data as {
      token: string;
      department: { id: string; name: string } | null;
      user: { firstname: string; lastname: string; email: string; role: ROLE };
    };

    sessionStorage.setItem('token', btoa(responseData.token));
    sessionStorage.setItem('user', btoa(JSON.stringify(responseData.user)));
    sessionStorage.setItem('department', btoa(JSON.stringify(responseData.department)));

    dispatch(
      login({
        isAdmin: responseData.user.role === ROLE.FD_ADMIN,
        isSuperAdmin: responseData.user.role === ROLE.ADMIN,
        user: responseData.user,
        token: responseData.token,
        isAuthenticated: true,
        department: responseData.department ? responseData.department : undefined,
      })
    );

    setEmail('');
    setPassword('');

    const from = location.state?.from?.pathname || '/';
    navigate(from, { replace: true });
  };

  return (
    <>
      <div className='d-flex justify-content-center align-items-center w-100 h-100'>
        <div className={style.LoginContainer}>
          <Form>
            <Form.Group controlId='formGroupHeader'>
              <h3>Login</h3>
            </Form.Group>
            <Form.Group className='mb-3' controlId='formGroupEmail'>
              <Form.Label>E-Mail</Form.Label>
              <Form.Control type='email' placeholder='E-Mail...' onChange={(e) => setEmail(e.target.value)} />
            </Form.Group>
            <Form.Group className='mb-3' controlId='formGroupPassword'>
              <Form.Label>Passwort</Form.Label>
              <Form.Control type='password' placeholder='Passwort...' onChange={(e) => setPassword(e.target.value)} />
            </Form.Group>
            <Form.Group className='mb-3' controlId='formGroupSignIn'>
              <Button onClick={() => handleLogin()}>Einloggen</Button>
            </Form.Group>
          </Form>
        </div>
      </div>
    </>
  );
}
